import { render, staticRenderFns } from "./JAreaLinkage.vue?vue&type=template&id=7d6a815f&scoped=true"
import script from "./JAreaLinkage.vue?vue&type=script&lang=js"
export * from "./JAreaLinkage.vue?vue&type=script&lang=js"
import style0 from "./JAreaLinkage.vue?vue&type=style&index=0&id=7d6a815f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6a815f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6a815f')) {
      api.createRecord('7d6a815f', component.options)
    } else {
      api.reload('7d6a815f', component.options)
    }
    module.hot.accept("./JAreaLinkage.vue?vue&type=template&id=7d6a815f&scoped=true", function () {
      api.rerender('7d6a815f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JAreaLinkage.vue"
export default component.exports